import { UploadContext } from '.'
import { MediaType } from '../types'

export function getMediaTypeFromContext(context: UploadContext): MediaType {
  if (context.desktop) return MediaType.Video
  if (context.stream && context.streamHasVideo) return MediaType.Video
  if (context.stream) return MediaType.Audio
  throw new Error('Cannot determine media type from context')
}
